module.exports = __webpack_public_path__ + "img/dingwei.39e29f44.png";